import React, { useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const MainLoader = () => {

  const [open, setOpen] = useState(false);
  const commonState = useSelector(state => state.commonState);

  useEffect(() => {
    (commonState.show_common_loader) ?
      setOpen(true) : setOpen(false)
  }, [commonState.show_common_loader])

  return (
    <>
      <div className="mainloader" style={{ display: (open) ? 'flex' : 'none' }}>
        <div className='main-loader-content'>
          <Image src='/assets/images/loader-img.svg' className='rotating-loader ' />
        </div>
      </div>
    </>
  )
}

export default MainLoader
